<!-- 确认上户dialog 组件 -->
<template>
  <section class="dialog">
    <mt-popup v-model="confirmVisible">
      <div class="confirm-content">
        <div class="title">{{ title[type] }}</div>
        <div class="sub-title">
          {{ subTitle[type][0] }}<br />{{ subTitle[type][1] }}
        </div>
        <div class="confirm-btn" @click="makeTel">联系我们</div>
        <div class="cancel-btn refuse-btn" @click.once="confirmHandle()">
          {{ btnValue }}
        </div>
        <div class="cancel-btn" @click="confirmVisible = false">取消</div>
      </div>
    </mt-popup>
  </section>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { Popup } from 'mint-ui'
import { getBusinessInfo, handleOrderSas, addWork } from '@/service/order'
import { B_ORDER_YS, isNewSelfAsignedMonthInLaw } from '@/business'
import { isNullOrEmpty } from '@/utils'

export default {
  inject: {
    reload: {}
  },
  //import引入的组件需要注入到对象中才能使用
  components: {
    [Popup.name]: Popup
  },
  data() {
    //这里存放数据
    return {
      confirmVisible: false,
      title: {
        refund: '申请退款',
        service: '申请售后'
      },
      subTitle: {
        refund: ['如果您有退款需求，请与我们联系沟通'],
        service: ['如果您对我们的服务不满意，联系', '我们协商解决哦～']
      }
    }
  },
  props: {
    worker: {},
    type: {
      default: 'refund',
      type: String
    },
    subtitle: {},
    order: {
      default: {},
      type: Object
    },
    isVirtual: {
      default: false,
      type: Boolean
    }
  },
  //监听属性 类似于data概念
  computed: {
    btnValue() {
      return `继续申请${this.type == 'refund' ? '退款' : '售后'} `
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    open() {
      this.confirmVisible = true
    },
    async makeTel() {
      // if (this.isVirtual) {
      //   const {serviceCode} = this.order
      //   const res = await getBusinessInfo(serviceCode)
      //   if (+res.code !== 1) {
      //     this.$$toast(res.msg)
      //     throw res
      //   }
      //   const {mobile} = res.data || {}
      //   if (isNullOrEmpty(mobile)) {
      //     this.$$toast('未查询到商家电话号码')
      //   } else {
      //     window.location.href = `tel:${mobile}`
      //   }
      // } else {
      const { inviteInfo = {} } = this.order
      const { inviteMobile } = inviteInfo
      window.location.href = `tel:${inviteMobile}`
      // }
    },
    confirmHandle() {
      const { orderId } = this.order
      const source = this.type === 'refund' ? 1 : 0
      const state = 0 // 无论是退款还是售后，都是申请
      const str = '申请成功,我们会在24小时内为您处理'
      const strMsg = this.type === 'refund' ? '退款' + str : '售后' + str
      handleOrderSas(orderId, source, state).then(flag => {
        const str = `${flag ? strMsg : '操作失败'}`
        this.confirmVisible = false
        this.$$toast(str)
        // 更新页面
        this.reload()
      })
      if (isNewSelfAsignedMonthInLaw(this.order)) {
        // 生成申请退款工单
        addWork({
          workType: 2,
          serviceDemand: '月嫂',
          source: 7,
          sourceId: this.order.orderId,
          sourceType: 2,
          remarks: this.type === 'refund' ? '上户前退款' : '上户后退款'
        })
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {}
}
</script>
<style lang="scss">
.mint-popup {
  background: #ffffff;
  border-radius: 28px !important;
}
</style>
<style lang="scss" scope>
@import '~@/assets/css/mixin';
//@import url(); 引入公共css类
.dialog {
  .confirm-content {
    width: rem(560px);
    // height: rem(520px);
    background: #ffffff;
    border-radius: rem(28px);
    text-align: center;
    padding-top: rem(40px);
    .title {
      font-size: rem(32px);
      color: #262626;
      font-weight: 700;
      text-align: center;
      margin-bottom: rem(4px);
    }
    .sub-title {
      margin-top: rem(16px);
      font-size: rem(26px);
      color: #4d4d4d;
      line-height: 1.5;
      text-align: center;
      border-bottom: 1px solid #f0f0f0;
      padding-bottom: rem(32px);
    }
    .confirm-btn {
      height: rem(87px);
      line-height: rem(87px);
      font-size: rem(32px);
      font-weight: 700;
      font-size: 700;
      color: #ff397e;
      border-bottom: 1px solid #f0f0f0;
    }
    .refuse-btn {
      border-bottom: 1px solid #f0f0f0;
    }
    .cancel-btn {
      height: rem(87px);
      line-height: rem(87px);
      font-size: rem(32px);
      color: #ff397e;
    }
  }
}
.kfcv-toast {
  z-index: 9999 !important;
}
</style>
